import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-like-icon',
  templateUrl: './general-like.component.html'
})
export class GeneralLikeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
